import React from 'react'

function footer() {
  return (
    <div className='footer'>
        <ul>
            <li>Trusty AG</li>
            <li>©EYOF Bakuriani 2025 OC</li>
            <li>Data privacy</li>
        </ul>

    </div>
  )
}

export default footer